<template>
  <div v-if="!loading">

    <div class="row">
      <div class="large-6 column large-centered">

        <div class="panel">
          <div class="text-center">
            <img style="max-width: 250px;" src="/assets-dev/images/app/logo_new_coloured.png" alt="ClassForKids logo">
            <hr>
            <h3>ClassForKids Updated <span>Terms &amp; Conditions for {{ parsedRole.toLowerCase() }}s</span></h3>
          </div>

          <div v-if="!buttonClicked">
            <UpdateTermsText :firstName='userRole.firstName'/>
            <ContractSummary />
            <div class="text-center">
              <button type="button" name="button" class="success" @click="showContract()">Review Changes</button>
            </div>
          </div>
          <div v-else>
            <ContractText/>
            <div class="panel callout" v-if="role == 'parent'">
              <MarketingPermissions   />
            </div>
            <AcceptContractButton :role="role" />
          </div>

        </div>
      </div>
    </div>
    </div>
    <div id="loadingSpinner" v-else class="text-center">
      <i class="fal fa-circle-notch fa-spin fa-4x fa-fw"></i>
      <span class="sr-only">Loading...</span>
  </div>
    
</template>

<script>
import UpdateTermsText from './UpdateTermsText';
import ContractSummary from './ContractSummary';
import ContractText from './ContractText';
import AcceptContractButton from './AcceptContractButton';
import MarketingPermissions from './MarketingPermissions';

export default {
  data() {
    return {
      buttonClicked: false,
      contractText: '',
      user: '',
      role: ''
    };
  },
  computed: {
    userRole() {
      return this.user;
    },
    loading() {
      return !this.$store.getters.contractSummaryMarkup != '';
    },
    parsedRole() {
      return this.role == 'parent' ? this.role : 'organiser';
    }
  },
  methods: {
    showContract() {
      this.buttonClicked = true;
      window.scrollTo(0, 0);
    }
  },

  components: {
    UpdateTermsText,
    ContractSummary,
    ContractText,
    AcceptContractButton,
    MarketingPermissions
  },
  created() {
    this.user = JSON.parse(this.$root.$el.dataset.contractUser);
    this.role = this.$root.$el.dataset.userRole;
    this.$store.dispatch('GET_CONTRACT_MARKUP', this.role);
    this.$store.dispatch('GET_CONTRACT_SUMMARY_MARKUP', this.role);
  }
};
</script>

<style>
#loadingSpinner {
  padding-top: 20%;
}
</style>
